import { GET_MATCHING_SUCCESS } from '@/state/types/data'

const initialState = {}

export default (previousState = initialState, { type, payload, meta }) => {
  switch (type) {
    case GET_MATCHING_SUCCESS:
      return {
        ...previousState,
        [meta.relatedTo]: payload.data.map(record => record.id),
      }
    default:
      return previousState
  }
}

export const getPossibleReferences = (state, referenceSource, reference, selectedIds = []) => {
  const possibleValues = state.rest.references.possibleValues[referenceSource]
    ? Array.from(state.rest.references.possibleValues[referenceSource])
    : []
  selectedIds.forEach(id => possibleValues.some(value => value == id) || possibleValues.unshift(id))
  return possibleValues
    .map(id => state.rest[reference].data[id])
    .filter(r => typeof r !== 'undefined')
}



// WEBPACK FOOTER //
// ./state/reducers/references/possibleValues.js